import { render, staticRenderFns } from "./photoIdentifing.vue?vue&type=template&id=26358f56&scoped=true&"
import script from "./photoIdentifing.vue?vue&type=script&lang=js&"
export * from "./photoIdentifing.vue?vue&type=script&lang=js&"
import style0 from "./photoIdentifing.vue?vue&type=style&index=0&id=26358f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26358f56",
  null
  
)

export default component.exports